export const columns = [
    {
        name: "ID",
        sortable: true,
    },
    {
        name: "Created Date",
        sortable: false,
    },
    {
        name: "Name",
        sortable: true,
    },
    {
        name: "Rate",
        sortable: false,
    },
    {
        name: "Tax ID",
        sortable: false,
    },
];